import type { FC } from "react";
import { ApplicationLayout } from "./application-layout";

export const MomentFormLayout: FC = () => {
  return <ApplicationLayout />;
};
